var _defs, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-807db665-5162-413c-86f9-84c5fb5006a6",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-3e159377-3f02-4a81-964b-d6c1ea94c0b2{fill:#fff;}.uuid-c8386fee-a1be-4a6f-8c39-81b049f5727b{fill:#575757;}.uuid-ec95ab8f-00e1-421e-976d-d292718348a3{fill:#b5d77a;}.uuid-8333cc5b-e00c-4ac2-9793-490a17e39d9f{fill:#cf016d;}.uuid-f6fd465c-14c5-43d4-9424-16cabe622311{fill:#7893be;}.uuid-1c46d8a9-d488-40e7-88fd-76072a3ec1b6{fill:#76b71c;}.uuid-cd485b57-ab95-474a-95ae-1a6e97e55674{fill:#b15196;}.uuid-1acc7928-7ce4-408d-b1be-069ef03c2ab9{fill:#0197e4;}.uuid-757cf307-ad9c-4cd1-b731-d2b9cac62f49{fill:#f19542;}.uuid-010f1c45-1c63-4943-b4e1-3881c43889f2{fill:#ac700e;}.uuid-9bf7d780-9e78-40c0-a3ec-c5f799632823{fill:#2c7097;}.uuid-5b4ac08f-3e4a-4409-a984-d3c0f0d226c5{fill:#678663;}.uuid-e40af397-aee7-4d5d-ad56-b89e9e908493{fill:#279e40;}.uuid-09f9f897-9590-45fd-a17c-8c50d9d6de50{fill:#98814a;}.uuid-a4858955-91c7-48b2-ab26-33d6b2995dd9{fill:#8e8e8e;}.uuid-e542efca-edc1-4ddf-b176-574facb21f66{fill:#6a73bb;}.uuid-f9741669-397e-453e-840b-6730bc544802{fill:#387472;}.uuid-9a8e02e8-4c9e-43dc-b782-abd74f8c37b2{fill:#d0d0d0;}.uuid-0be42ac3-f062-4521-88b9-74539647bd81{fill:#cc000d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-3e159377-3f02-4a81-964b-d6c1ea94c0b2",
    d: "m-.5-.5h513v513H-.5V-.5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-c8386fee-a1be-4a6f-8c39-81b049f5727b",
    cx: 49.88,
    cy: 260.58,
    r: 13.74
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-9a8e02e8-4c9e-43dc-b782-abd74f8c37b2",
    cx: 77.37,
    cy: 223.94,
    r: 13.74
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1acc7928-7ce4-408d-b1be-069ef03c2ab9",
    cx: 114.01,
    cy: 223.94,
    r: 13.74
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-5b4ac08f-3e4a-4409-a984-d3c0f0d226c5",
    cx: 178.13,
    cy: 223.94,
    r: 13.74
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-9bf7d780-9e78-40c0-a3ec-c5f799632823",
    cx: 214.78,
    cy: 223.94,
    r: 13.74
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-ec95ab8f-00e1-421e-976d-d292718348a3",
    cx: 288.06,
    cy: 223.94,
    r: 13.74
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-010f1c45-1c63-4943-b4e1-3881c43889f2",
    cx: 343.03,
    cy: 223.94,
    r: 13.74
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-f9741669-397e-453e-840b-6730bc544802",
    cx: 214.78,
    cy: 260.58,
    r: 13.74
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-f6fd465c-14c5-43d4-9424-16cabe622311",
    cx: 141.02,
    cy: 260.58,
    r: 13.74
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-a4858955-91c7-48b2-ab26-33d6b2995dd9",
    cx: 49.88,
    cy: 297.42,
    r: 13.74
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-e40af397-aee7-4d5d-ad56-b89e9e908493",
    cx: 260.58,
    cy: 260.58,
    r: 13.74
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-cd485b57-ab95-474a-95ae-1a6e97e55674",
    cx: 379.67,
    cy: 260.58,
    r: 13.74
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-757cf307-ad9c-4cd1-b731-d2b9cac62f49",
    cx: 416.31,
    cy: 260.58,
    r: 13.74
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-8333cc5b-e00c-4ac2-9793-490a17e39d9f",
    cx: 416.31,
    cy: 223.94,
    r: 13.74
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-0be42ac3-f062-4521-88b9-74539647bd81",
    cx: 462.12,
    cy: 223.94,
    r: 13.74
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1c46d8a9-d488-40e7-88fd-76072a3ec1b6",
    cx: 260.58,
    cy: 297.42,
    r: 13.74
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-09f9f897-9590-45fd-a17c-8c50d9d6de50",
    cx: 379.67,
    cy: 297.42,
    r: 13.74
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-e542efca-edc1-4ddf-b176-574facb21f66",
    cx: 178.13,
    cy: 297.42,
    r: 13.74
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSt);
export default __webpack_public_path__ + "static/media/icon_st.9cb1313b2fe60c3e22df355af55c26c7.svg";
export { ForwardRef as ReactComponent };